import each from 'lodash/each';

import logger from '../../utils/logger';

class PerfectAudience {
  _append(id, revenue, productId) {
    window._pa = window._pa || {};
    if (revenue) _pa.revenue = revenue.toFixed(2);
    if (productId) _pa.productId = productId;
    var pa = document.createElement('script');
    pa.type = 'text/javascript';
    pa.async = true;
    pa.src = ('https:' == document.location.protocol ? 'https:' : 'http:') + `//tag.marinsm.com/serve/${id}.js`;
    var s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(pa, s);
  }

  _track(idGlobal, idCampaign, revenue, productId) {
    if (logger.checkCampaign(idCampaign)) {
      this._append(idCampaign, revenue, productId);

      logger.log(`Campaign specific ${idCampaign} track event`);
    }

    if (logger.checkGlobal(idGlobal, idCampaign)) {
      this._append(idGlobal, revenue, productId);

      logger.log(`Global ${idGlobal} track event`);
    }
  }

  clientViewSales({ state }) {
    logger.groupCollapsed('Client Perfect Audience');

    this._track(state.campaign.tracking.global.perfect, state.campaign.tracking.campaign.perfect);

    logger.groupEnd();
  }

  clientViewThankYou({ state }) {
    logger.groupCollapsed('Client Perfect Audience');

    each(state.order.orders, order => {
      logger.groupCollapsed(order.campaign_name);

      this._track(state.order.tracking[order.analytics_cid].global.perfect, state.order.tracking[order.analytics_cid].campaign.perfect, order.sale_total + order.shipping_discount - order.shipping_total, order.campaign_name);

      logger.groupEnd();
    });

    logger.groupEnd();
  }
};

export default new PerfectAudience();